function closeSearch() {
  let elements = document.querySelectorAll(".search-modal__form");

  elements.forEach((element) => {
    element.removeAttribute("open");
  });

  let SearchBarDiv = document.getElementById("searchBarDiv");
  SearchBarDiv.style.position = "relative";
  SearchBarDiv.style.top = "auto";
  SearchBarDiv.style.left = "auto";

  document.body.style.overflowY = "scroll";
  document.body.style.position = "relative";
}

function showSearch() {
  let element = document.querySelector(".search-modal__form");
  element.setAttribute("open", "true");
}

function saveChosenDogbreed() {
  let dogbreedSelector = document.getElementById("dogbreeds");
  let dogbreedText = document.getElementById("hondenkiezerText");
  localStorage.setItem("dogbreed", dogbreedSelector.value);
  dogbreedUrl = dogbreedSelector[dogbreedSelector.options.selectedIndex].value;
  if (parseInt(dogbreedUrl) == 0) {
    dogbreedText.classList.remove("opacity-0");
  } else {
    window.location.href = "/" + dogbreedUrl + "/";
  }
}

function showFiltersMobile() {
  let filtersDiv = document.querySelector(".filters");
  filtersDiv.style.display = "block";
}
function hideFiltersMobile() {
  let filtersDiv = document.querySelector(".filters");
  filtersDiv.style.display = "none";
  scrollToFirstProduct();
}

function scrollToFirstProduct() {
  let productGrid = document.getElementById("ProductGridContainer");
  if (!productGrid) return;

  requestAnimationFrame(function () {
    let offset = 0;
    let stickyBar = document.getElementById("CollectionFilterSortBar");
    let headerGroup = document.getElementsByClassName("shopify-section-group-header-group")[0];

    if (stickyBar && stickyBar.classList.contains("fixed")) {
      offset = stickyBar.getBoundingClientRect().bottom;
    } else if (headerGroup) {
      offset = Math.max(headerGroup.getBoundingClientRect().bottom, 0);
    }

    let padding = window.innerWidth >= 1024 ? 40 : 16;
    let targetY = productGrid.getBoundingClientRect().top + window.pageYOffset - offset - padding;
    window.scrollTo({ top: Math.max(targetY, 0), behavior: "smooth" });
  });
}

// collection page
function categoryReadMore() {
  let categoryText = document.getElementsByClassName("collectionEnd");
  categoryText[0].scrollIntoView({ behavior: "smooth", block: "start" });
}

async function fetchProduct(productUrl, productCounter, sliderCheck) {
  const url = "https://www.autobench.nl/" + productUrl;
  let product = await await fetch(url, { method: "GET" })
    .then((response) => response.json())
    .then((data) => (prod = data));
  //  voorraad/stock
  showStock(product, productCounter);
  showCartButton(product, productCounter);
  //  measurements
  if (
    product.data_02 != "0x0x0" &&
    product.data_02 != "" &&
    product.title.includes("bench")
  ) {
    // showMeasurements(product, productCounter);
  }
  //   variants
  if (sliderCheck == false || sliderCheck == undefined) {
    let variants = Object.entries(product.variants);
    if (variants.length > 1) {
      showVariants(product, productCounter);
    }
  }
}

function showCartButton(product, productCounter) {
  let cartButton = document.getElementsByClassName("CartButton");
  if (product.stock.level > 0) {
    // pass
  } else {
    cartButton[productCounter].classList.add("hidden");
  }
}

function showMeasurements(product, productCounter) {
  let afmetingenDiv = document.getElementsByClassName("afmetingen");
  let data02 = product.data_02;
  let measurements = data02;
  if (data02.includes("x") && data02.includes("-")) {
    let afmetingList = data02.split("-");
    measurements = afmetingList[1];
    measurements = afmetingList[1].split("x");
  }
  let hoogte = measurements[0];
  let breedte = measurements[1];
  let diepte = measurements[2];

  if (data02.includes("LxBxH")) {
    afmetingList = data02.split("-");
    afmetingList = afmetingList[1].trim().split("x");
    hoogte = afmetingList[2];
    breedte = afmetingList[1];
    diepte = afmetingList[0];
  } else if (data02.includes("BxDxH")) {
    afmetingList = data02.split("-");
    afmetingList = afmetingList[1].trim().split("x");
    hoogte = afmetingList[2];
    breedte = afmetingList[0];
    diepte = afmetingList[1];
  } else if (data02.includes("LxBxDikte")) {
    afmetingList = data02.split("-");
    afmetingList = afmetingList[1].trim().split("x");
    hoogte = afmetingList[2];
    breedte = afmetingList[1];
    diepte = afmetingList[0];
  }

  for (let i = 0; i < measurements.length; i++) {
    let liElement = document.createElement("li");
    liElement.className = "pr-2 text-xs md:text-sm";
    if (i == 0) {
      liElement.innerHTML =
        "<span class='font-bold text-base'>H </span>" + hoogte + "cm";
    } else if (i == 1) {
      liElement.innerHTML =
        "<span class='font-bold text-base'>B </span>" + breedte + "cm";
    } else {
      liElement.innerHTML =
        "<span class='font-bold text-base'>D </span> " + diepte + "cm";
    }
    afmetingenDiv[productCounter].children[0].append(liElement);
  }
}

// product page
function scrollToSpecs() {
  let specsDiv = document.getElementsByClassName("productSpecifications");
  specsDiv[0].scrollIntoView({ behavior: "smooth", block: "center" });
}

function scrollToRelated() {
  let relatedDiv = document.getElementsByClassName("productRelated");
  relatedDiv[0].scrollIntoView({ behavior: "smooth", block: "center" });
}

function showProductText() {
  let productTextDiv = document.getElementsByClassName("productTextContent");
  const readmoreBtn = document.getElementById("readMoreBtn");
  readmoreBtn.remove();
  productTextDiv[0].classList.remove("overflow-hidden");
  productTextDiv[0].style.maxHeight = "fit-content";
}

// navigation functions
function hideCategories(event) {
  let categoriesDiv = document.getElementById("categoriesContainer");

  if (categoriesDiv.contains(event.target)) return; // don't hide if clicked inside

  if (categoriesDiv.style.visibility == "visible") {
    categoriesDiv.style.visibility = "hidden";
    categoriesDiv.style.maxHeight = "0px";
    categoriesDiv.style.opacity = "0";
    document.body.style.overflowY = "scroll";
    document.body.style.position = "relative";
    document.body.style.left = "0px";
    document.body.style.right = "0px";
  }

  if (document.body.style.position != "relative") {
    if (document.body.style.position == "fixed" && body.style.overflowY == "hidden") {
      document.body.style.overflowY = "scroll";
      document.body.style.position = "relative"; 
    }
  }
}

  let catCheck = 0;
  function showCategories() {
    let categoriesDiv = document.getElementById("categoriesContainer");
    if (categoriesDiv.style.visibility == "visible") {
      categoriesDiv.style.visibility = "hidden";
      categoriesDiv.style.maxHeight = "0px";
      categoriesDiv.style.opacity = "0";
      document.body.style.overflowY = "scroll";
      document.body.style.position = "relative";
    } else {
      catCheck = 1;
      categoriesDiv.style.visibility = "visible";
      categoriesDiv.style.maxHeight = "99999px";
      categoriesDiv.style.opacity = "1";
      document.body.style.overflowY = "scroll";
      document.body.style.position = "fixed";
      document.body.style.left = "0px";
      document.body.style.right = "0px";
    }
    event.stopPropagation();
  }

  // toggle fags on textpage
  function showFaq(ele) {
    let faqDiv = ele.nextElementSibling;
    if (faqDiv.classList.contains("!hidden")) {
      faqDiv.classList.remove("!hidden");
      ele.parentElement.classList.add("min-h-[80px]");
      ele.children[1].style.rotate = "180deg";
    } else {
      faqDiv.classList.add("!hidden");
      ele.parentElement.classList.remove("min-h-[80px]");
      ele.children[1].style.rotate = "360deg";
    }
  }

  // SHOPIFY NEW

  // collection/category page functions
  // Update the variant ID when the selection changes
  const variantSelectors = document.querySelectorAll(".variationsPicker");

  variantSelectors.forEach((selector) => {
    selector.addEventListener("change", function () {
      selector.parentElement.parentElement.children[0].children[2].value =
        selector.value;
      let selectedText = selector.options[selector.selectedIndex].text;
      let splitText = selectedText.split(" - ");
      // change price
      selector.parentElement.parentElement.parentElement.children[1].children[2].innerText =
        splitText[1];
      // console.log(selector);
    });
  });

  // timeout with promise
  function timeout(ms) {
    // console.log('timeout called');
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  function cartBuyXgetYAutomaticPlus() {
    let chosenProducts = [];
    chosenProducts.push(
      { id: parseInt(50171101610312), quantity: 1 },
      { id: parseInt(50169778864456), quantity: 1 },
      { id: parseInt(50171119403336), quantity: 1 }
    );
    // console.log(chosenProducts);
    addMultipleVariantsToCart(chosenProducts);
  }
  function cartBuyXgetYAutomaticMinus() {
    let updates = {
      50171101610312: 2,
      50169778864456: 3,
      50171119403336: 1,
    };

    fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  // Free item rules: when an added product matches a rule, its free variant is added to the cart.
  // Set `enabled: false` to park a rule without deleting it.
  const discountFreeItemRules = [
    {
      // Maelson reisbench 62 / 72
      enabled: true,
      vendors: ['Maelson'],
      titleKeyword: 'reisbench',
      titleSizes: ['62', '72'],
      freeItemVariantId: 50170705772872, // TODO: variant id of the free product for the small reisbenches
    },
    {
      // Maelson reisbench 82 / 92 / 105
      enabled: true,
      vendors: ['Maelson'],
      titleKeyword: 'reisbench',
      titleSizes: ['82', '92', '105'],
      freeItemVariantId: 50170706329928, // TODO: variant id of the free product for the large reisbenches
    },
    {
      // Previous logic: any product of these vendors (or these variant ids) gets the free long trainer
      enabled: false,
      variantIds: [],
      vendors: ['Maelson', 'Hundos'],
      freeItemVariantId: 53900412125512, // free long trainer
    },
  ];

  function freeItemRuleMatches(rule, triggerVariantId, vendor, productTitle) {
    if (rule.variantIds && rule.variantIds.includes(String(triggerVariantId))) return true;
    if (rule.vendors && !rule.vendors.includes(String(vendor))) return false;
    if (rule.titleKeyword) {
      const title = String(productTitle || '').toLowerCase();
      if (!title.includes(rule.titleKeyword.toLowerCase())) return false;
      // match sizes as whole numbers ("62cm" matches "62", "162" doesn't)
      if (rule.titleSizes && !rule.titleSizes.some((size) => new RegExp(`(^|\\D)${size}(\\D|$)`).test(title))) return false;
    }
    return !!rule.vendors || !!rule.titleKeyword;
  }

  async function cartHasVariant(variantId) {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      return cart.items.some((item) => item.variant_id === parseInt(variantId));
    } catch (error) {
      console.error('Error checking cart contents:', error);
      return false;
    }
  }

  async function addDiscountFreeItem(triggerVariantId, vendor, productTitle) {
    const rule = discountFreeItemRules.find(
      (rule) => rule.enabled && rule.freeItemVariantId && freeItemRuleMatches(rule, triggerVariantId, vendor, productTitle)
    );
    if (!rule) return;

    if (await cartHasVariant(rule.freeItemVariantId)) return;

    let chosenProducts = [];
    chosenProducts.push(
      { id: parseInt(rule.freeItemVariantId), quantity: 1 },
    );
    // console.log(chosenProducts);
    addMultipleVariantsToCart(chosenProducts);
  }

  // add multiple prods to cart at once
  const addMultipleVariantsToCart = async (items) => {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!response.ok) {
        throw new Error("Failed to add items to cart");
      }

      await response.json();
      cartUpdate(); // Call function to update the cart drawer
    } catch (error) {
      console.error("Error adding products:", error);
    }
  };

  function cartUpdate() {
    // console.log("cartUpdate");
    let drawerElement = document.querySelector(".drawer");
    let drawerEmptyElement = document.querySelector(".drawer__inner-empty");
    if (drawerEmptyElement) {
      drawerEmptyElement.remove();
    }
    if (drawerElement.classList.contains("is-empty")) {
      drawerElement.classList.remove("is-empty");
    }
    fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }
      })
      .catch((e) => {
        console.error(e);
      });
    document.getElementById("cart-icon-bubble").click();
    // console.log("end cart update");
  }

  function trackPagesVisited() {
    const currentPage = window.location.pathname;
    const visitedPages = JSON.parse(localStorage.getItem("visitedPages")) || [];

    // Remove current page if it already exists to avoid duplicates
    const filteredPages = visitedPages.filter(page => page !== currentPage);

    // Add current page to the beginning of the array
    filteredPages.unshift(currentPage);

    // Keep only the 3 most recent pages
    const recentPages = filteredPages.slice(0, 3);

    localStorage.setItem("visitedPages", JSON.stringify(recentPages));
  }
  trackPagesVisited();



  let lastScroll = 0;
  const header = document.getElementsByClassName('shopify-section-group-header-group')[0];
  const scrollThreshold = 5;

  window.addEventListener('scroll', () => {
    // Clamp negative values from iOS rubber-band overscroll so bounce jitter
    // near the top isn't misread as "scrolling down".
    const current = Math.max(window.pageYOffset, 0);
    const delta = current - lastScroll;

    if (current <= scrollThreshold) {
      header.classList.remove('hide');
    } else if (Math.abs(delta) > scrollThreshold) {
      if (delta > 0) {
        header.classList.add('hide');   // scrolling down
      } else {
        header.classList.remove('hide'); // scrolling up
      }
    }
    lastScroll = current;
  }, { passive: true });
